import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("锁定")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("解锁")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("创建支付子包")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("凭证")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("锁定")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("解锁")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("确定")

import { ref, reactive, onActivated } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { statusMap } from '@/views/typeMapping/Financial'
import dayjs from 'dayjs'
import { exportHandle } from '@/utils/index'
import PayPackageDetails from '@/views/ViewsComponents/pay/PayPackageDetails.vue'
import AdvancePayment from '@/views/ViewsComponents/financial/AdvancePayment.vue'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/cost_cash_packs': fetchList,
  // 锁定解锁
  'PUT/cost_cash_packs/{id}/lock_or_unlock': lock_or_unlockApi,
  // 删除包
  'DELETE/cost_cash_packs/{id}': delPackageApi,
  // 导出
  'POST/cost_cash_packs/detail/export': exportApi,
  // 修改包名
  'POST/cost_cash_packs/update':packsUpdateApi,
  // 创建支付子包
  'POST/cost_cash_packs/generate_payment_sub_packages':generate_payment_sub_packagesApi,
  // 生成凭证
  'POST/cost_cash_packs/detail/generate_voucher': generate_voucherApi
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)
const searchHandle = (params: any) => {
  fetchData({
    ...params,
    status: params.status || null
  })

}

onActivated(() => {
  searchHandle({})
})

const searchConfig = ref([
  {
    label: '包名',
    value: '',
    upKey: 'name',
  },
  {
    label: '创建人',
    value: '',
    upKey: 'creator',
  },
  {
    label: '译员ID',
    value: '',
    upKey: 'resourceId',
  },
  {
    type: "TIME",
    label: "创建时间",
    value: '',
    upKey: 'createdDate',
    props: { 'value-format': 'YYYY-MM-DD' }
  },
  {
    type: "TIME",
    label: "锁定时间",
    value: '',
    upKey: 'lockDate',
    props: { 'value-format': 'YYYY-MM-DD' }
  },
  {
    type: "TIME",
    label: "关闭时间",
    value: '',
    upKey: 'closeDate',
    props: { 'value-format': 'YYYY-MM-DD' }
  },
  {
    type: 'SELECT',
    label: '状态',
    value: '',
    upKey: 'status',
    options: [
      { label: '未锁定', id: 'unLocked' },
      { label: '已锁定', id: 'locked' },
      { label: '支付完成', id: 'paid' },
    ],
    props: { clearable: true, placeholder: '请选择状态' },
    seleProps: { label: 'label', valueName: 'id' }
  },
  // {
  //   label: '译员ID',
  //   value: '',
  //   upKey: 'resourceId',
  // },
])


// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm('是否删除此包', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    MI_identify.value = true
    return delPackageApi({ id: row.id })
  })
  .then(() => {
    MI_identify.value = false
    fetchData(MI_params)
    ElMessage.success('删除成功')
  }).catch(() => {
    MI_identify.value = false
  })
}

// 锁定解锁
const toggleLockHandle = (row: {id: string}) => {
  MI_identify.value = true
  lock_or_unlockApi({id: row.id}).then(() => {
    ElMessage.success('成功')
    MI_identify.value = false
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
  })
}

// 导出
const exportRowHandle = (row: any) => {
  ElMessageBox.confirm('请确认是否导出' + row.id, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    MI_identify.value = true
    return exportHandle(exportApi, {packId: row.id})
  }).finally(() => {
    MI_identify.value = false
  })
}

// 详情
let detailsRow: {id: string} = reactive({id: ''})
const isShowDetails = ref<boolean>(false)
const showDetails = (row: any) => {
  Object.assign(detailsRow, row)
  isShowDetails.value = true
}

// -------
const formatTime = (row: Object, column: any, cellValue: number) => {
  if(!cellValue) return ''
  return dayjs(cellValue).format('YYYY-MM-DD')
}

const dataStatus=[{value:'processed',label:'已处理'},
    {value:'pending_processing',label:'待处理'},
    {value:'partial_processing',label:'部分处理'}]
const datastatusFilter=(status:string)=>{
  let res=dataStatus.find((el:any)=>el.value==status)
  return res?res.label:''
}

// 修改
const currentPackageId=ref("")
const modifyVisiable=ref(false)
const newPackageName=ref("")
const modifyHandle=(data:any)=>{
  currentPackageId.value=data.id
  modifyVisiable.value=true
  newPackageName.value=data.name
}
const updateLoading=ref(false)
const closeModify=()=>{
  currentPackageId.value=""
  newPackageName.value=""
}
const modifyName=()=>{
  if(newPackageName.value==''||newPackageName.value==undefined||newPackageName.value==null){
    ElMessage.warning("请输入支付包名称")
    return
  }
  let params={
    id:currentPackageId.value,
    name:newPackageName.value
  }
  updateLoading.value=true
  packsUpdateApi(params).then(()=>{
    ElMessage.success('修改成功')
    modifyVisiable.value=false
    searchHandle({})
  }).finally(()=>{
    updateLoading.value=false
  })
}

// 创建支付子包
const cascaderProps = { multiple: true}
const payMethodVal = ref([])
const payMethodOps = [
  { label: 'PAYPAL', value: 'paypal' },
  { label: 'WISE', value: 'wise' },
  { 
    label: 'BANKTRANSFER',
    value: 'banktransfer',
    children: [
      { label: '深圳市昆仲科技有限公司（云账户）', value: '深圳市昆仲科技有限公司（云账户）' },
      { label: 'CCJK CO LIMITED', value: 'CCJK CO LIMITED' },
      { label: '深圳市昆仲科技有限公司', value: '深圳市昆仲科技有限公司' },
    ]
  },
  { label: 'PAYONEER', value: 'payoneer' },
  { label: 'PAYONEERBANKTRANSFER', value: 'payoneerbanktransfer' },
]

const showSubpackage = ref<boolean>(false)
const previousId = ref("")
const showAddSubpackage = (row:any)=>{
  showSubpackage.value = true
  previousId.value = row.id
}
const createSubpackage = () => {
  let payMethodsStr = payMethodVal.value.reduce((arr, item) => {
    if(item.length > 1){
      return arr.concat(item.join('/'))
    }
    return arr.concat(item)
  }, [])
  generate_payment_sub_packagesApi({
    payMethods: payMethodsStr,
    id: previousId.value
  }).then((res:any)=>{
    ElMessage.success("创建成功")
    showSubpackage.value=false
    fetchData(MI_params)
  })
}


// 生成凭证
/* const isShowVoucher = ref<boolean>(false)
const voucherEle = ref()
const voucherObj = reactive({
  deliverTime: [], voucherSource: 'INCOME', dataSourceType: '',
}) */
const generateVoucher = (row: {id: number}) => {
  ElMessageBox.confirm('请确认是否生成凭证?', '提示').then(() => {
    MI_identify.value = true
    return generate_voucherApi({
      voucherSource: 'CASH_SINGLE_TRANSLATOR',
      packIds: [row.id]
    })
  }).then(() => {
    ElMessage.success('成功生成凭证')
    fetchData(MI_params)
  }).finally(() => {
    MI_identify.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "提现支付包" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_collapse, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_collapse_item, { title: "提现支付包-搜索" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
              initSearch: false,
              title: true,
              searchConfig: searchConfig.value,
            }, { onSearchFn: searchHandle }), null, 16)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                ref: "tb",
                border: "",
                class: "mt-10",
                data: _unref(MI_tableData),
                "max-height": _unref(MI_height),
                "row-key": "id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "ID",
                    prop: "id",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "包名",
                    prop: "name",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "创建人",
                    prop: "creator",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "创建时间",
                    prop: "createdTime",
                    "show-overflow-tooltip": "",
                    formatter: formatTime
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "锁定时间",
                    prop: "lockTime",
                    "show-overflow-tooltip": "",
                    formatter: formatTime
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "关闭时间",
                    prop: "closeTime",
                    "show-overflow-tooltip": "",
                    formatter: formatTime
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "进度",
                    prop: "dataStatus",
                    "show-overflow-tooltip": "",
                    formatter: (row)=>datastatusFilter(row.dataStatus)
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    label: "状态",
                    prop: "status",
                    "show-overflow-tooltip": "",
                    formatter: (row) => _unref(statusMap)()[row.status]
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    label: "支付方式",
                    prop: "payMethods",
                    "show-overflow-tooltip": ""
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(row.payMethods?.join(',').toUpperCase()), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "操作",
                    width: "280"
                  }, {
                    default: _withCtx(({ row }) => [
                      (!row.parentId)
                        ? (_openBlock(), _createBlock(_component_el_space, { key: 0 }, {
                            default: _withCtx(() => [
                              (row.status === 'unLocked')
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 0,
                                    onClick: ($event: any) => (modifyHandle(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_1
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_link, {
                                onClick: ($event: any) => (showDetails(row))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_2
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              (row.status === 'unLocked')
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 1,
                                    onClick: ($event: any) => (toggleLockHandle(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_3
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (row.status === 'locked')
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 2,
                                    onClick: ($event: any) => (toggleLockHandle(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_4
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (row.status === 'unLocked')
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 3,
                                    type: "danger",
                                    onClick: ($event: any) => (delHandle(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_5
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (row.status === 'locked')
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 4,
                                    onClick: ($event: any) => (exportRowHandle(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_6
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (row.status === 'locked')
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 5,
                                    onClick: ($event: any) => (showAddSubpackage(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_7
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_link, {
                                onClick: ($event: any) => (generateVoucher(row)),
                                type: "primary"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_el_space, { key: 1 }, {
                            default: _withCtx(() => [
                              (row.status === 'unLocked')
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 0,
                                    type: "danger",
                                    onClick: ($event: any) => (delHandle(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_9
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (row.status === 'unLocked')
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 1,
                                    onClick: ($event: any) => (toggleLockHandle(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_10
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (row.status === 'locked')
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 2,
                                    onClick: ($event: any) => (toggleLockHandle(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "max-height"])), [
                [_directive_loading, _unref(MI_identify)]
              ]),
              _createVNode(_component_el_pagination, {
                background: "",
                small: "",
                total: _unref(MI_total),
                currentPage: _unref(page),
                "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
                "page-size": _unref(size),
                "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
                class: "mb-5 mt-5",
                "page-sizes": [10, 30, 50, 100, 200, 500],
                layout: "sizes, prev, pager, next, total, jumper",
                onCurrentChange: _unref(MI_pageChange),
                onSizeChange: _unref(MI_sizeChange)
              }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "预付处理情况表",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(AdvancePayment)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: _unref(detailsRow).name,
      fullscreen: "",
      modelValue: isShowDetails.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isShowDetails).value = $event))
    }, {
      default: _withCtx(() => [
        (isShowDetails.value)
          ? (_openBlock(), _createBlock(PayPackageDetails, {
              key: 0,
              id: _unref(detailsRow).id
            }, null, 8, ["id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      onClose: closeModify,
      title: "修改支付包名称",
      modelValue: modifyVisiable.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modifyVisiable).value = $event)),
      width: "350"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (modifyVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: modifyName
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          placeholder: "请输入支付包名称",
          modelValue: newPackageName.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newPackageName).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "创建支付子包",
      onClose: _cache[8] || (_cache[8] = ($event: any) => (payMethodVal.value=[])),
      modelValue: showSubpackage.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showSubpackage).value = $event)),
      width: "600"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (showSubpackage.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: createSubpackage
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_cascader, {
          "collapse-tags": "",
          modelValue: payMethodVal.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((payMethodVal).value = $event)),
          options: payMethodOps,
          props: cascaderProps,
          placeholder: "请选择支付方式"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})